import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum } from "@datadog/browser-rum";
import { CLOUD_API } from "@skydio/api_util/src";
import { useEffect, useState } from "react";
import { setGlobalEventProperty } from "utils/trackEvent";
import { v4 as uuidv4 } from "uuid";

// Stable session ID generated at module load time for analytics correlation
const sessionId = uuidv4();
setGlobalEventProperty("sessionId", sessionId);

/**
 * Enrich datadog context with user and organization information
 */
export function useEnrichDatadogContext({
  user,
  organizationUuid,
}: {
  user?: CLOUD_API.APIUser;
  organizationUuid?: string;
}) {
  const [hasUser, setHasUser] = useState(false);
  const [hasOrgUuid, setHasOrgUuid] = useState(false);
  useEffect(() => {
    if (user) {
      const ddUser = {
        id: user.uuid,
        email: user.email,
        org: user.organizationId,
        org_permission: CLOUD_API.modules.organizations.utils.getOrgPermissionKey(
          user.organizationPermission
        ),
      };
      datadogRum.setUser(ddUser);
      datadogLogs.setUser(ddUser);
      setHasUser(true);
    }
  }, [user]);

  useEffect(() => {
    if (!organizationUuid) return;
    setGlobalEventProperty("requestedOrgId", organizationUuid);
    setHasOrgUuid(true);
  }, [organizationUuid]);

  return { hasUser, hasOrgUuid };
}
